import Vue from 'vue'

export const EventBus = new Vue()

export default EventBus



// WEBPACK FOOTER //
// ./src/lib/eventBus.js